import cn from 'classnames';
import ProductAddToCartButton from '@components/product/ProductAddToCartButton';
import AddToCartCTA from '_components/Product/AddToCartCTA';
import { FEATURE_FLAG_PDP_2026_1 } from '@config/feature-flag';
import { ATC_SOURCES } from '@utils/cart/atcSource';

import styles from './AddToCartButtonPersistent.module.scss';

const ProductAddToCartButtonPersistent = ({
  isVisible = false,
  prismicDealsBannerTitles = [],
}: {
  isVisible: boolean;
  prismicDealsBannerTitles?: string[];
}) => (
  <div className={cn(styles.container, { [styles.open]: isVisible })}>
    {FEATURE_FLAG_PDP_2026_1 ? (
      // The legacy mobile persistent bar is the PDP's sticky ATC wherever
      // FEATURE_FLAG_STICKY_ATC_BAR is off, so it reports as sticky too (ED-555).
      <AddToCartCTA
        atcSource={ATC_SOURCES.PDP_STICKY}
        prismicDealsBannerTitles={prismicDealsBannerTitles}
      />
    ) : (
      <ProductAddToCartButton atcSource={ATC_SOURCES.PDP_STICKY} />
    )}
  </div>
);

export default ProductAddToCartButtonPersistent;
